/**
 * EMA-web 入口
 * ------------------------------------------------------------
 * 启动顺序（对齐原型 L6980-7003，逐步补齐）：
 *   1. 全局样式（reset → tokens.css → global → dark）
 *   2. Pinia（领域层 store 容器）
 *   3. ThemeProvider（亮/暗 + 语言，先于 App 挂载）
 *   4. Vue Router（壳层导航 + 视图栈）
 *   5. App.vue 挂载
 *
 * 当前 M0 里程碑只跑通壳层三栏 + 亮暗切换 + 路由。
 * 领域层 / 数据层 / 特性层在 M1-M5 逐阶段填充。
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './shell/router'
import { initTheme } from './shell/theme/useTheme'
import { useSchemaStore } from './domain/schema/store'
import { useScopeStore } from './domain/scope/store'
import { useToast } from './design/ui/UToast'
import { ensureAuthLoaded, isLoggedIn } from './data/api/auth-store'
import { hasPermi } from './shell/directives/has-permi'
import './styles/reset.css'
import './design/tokens.css'
import './styles/global.css'

const app = createApp(App)

// 1. Pinia：领域层 store 容器
const pinia = createPinia()
app.use(pinia)

// 2. 主题：读取 localStorage + 应用 data-mode 属性
initTheme()

// 3. Router：壳层导航
app.use(router)

// 3.1 指令：v-hasPermi 按钮级权限
app.directive('hasPermi', hasPermi)

// 4. 先恢复登录态，再决定是否预热业务数据（未登录不打业务接口）
void ensureAuthLoaded().finally(() => {
  if (isLoggedIn.value) {
    // 架构页面自行加载并绑定读取上下文，启动预热不能与它竞争重置快照。
    if (!location.hash.startsWith('#/arch')) {
      void useSchemaStore(pinia).load().catch(() => useToast().show('架构搜索索引暂时不可用，打开搜索时可重试。'))
    }
    void useScopeStore(pinia).init().catch(() => useToast().show('组织信息读取失败，请刷新重试。'))
  }
  app.mount('#app')
})
